<template lang="pug">
  div.p-wrap
    header.slot-header
      slot(name="header")
        | header
    main.slot-content
      slot(name="main")
        | main
    footer.slot-footer.p-footer
      slot(name="footer")
        | footer
</template>

<script>
  export default {
    name: 'MainLayout'
  }
</script>
